/**
 * Electron IPC uses structured clone; Vue reactive Proxies and some native error
 * shapes cannot cross the boundary. Round-trip through JSON for safe payloads.
 * @param {unknown} value
 */
export function toPlainForIpc (value) {
  if (value == null) {
    return value
  }
  if (typeof value !== 'object') {
    return value
  }
  try {
    return JSON.parse(JSON.stringify(value))
  } catch {
    if (Array.isArray(value)) {
      return value.map((item) => toPlainForIpc(item))
    }
    return Object.fromEntries(
      Object.entries(value).map(([k, v]) => [k, toPlainForIpc(v)])
    )
  }
}
